var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrasadamScanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.61 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#399;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M61.61,50c-.28,0-.56-.03-.84-.03-17.11,0-34.21,0-51.32,0-3.6,0-6.39-1.46-8.26-4.57-.73-1.2-1.15-2.53-1.17-3.93-.05-3.09-.02-6.18-.03-9.26,0-.08,.02-.15,.04-.27H58c-.1-1.84,.28-3.64-.39-5.39-.54-1.42-1.59-2.36-2.93-3.04C41.6,16.87,28.51,10.21,15.43,3.56c-.21-.11-.42-.22-.71-.36l1.61-3.2c.25,.12,.47,.21,.68,.32,13.05,6.63,26.09,13.27,39.15,19.89,3,1.52,4.88,3.82,5.37,7.19,.01,.08,.05,.15,.08,.22v22.38ZM3.65,35.56c-.02,.1-.04,.18-.04,.25,0,1.72-.06,3.45,.03,5.17,.04,.78,.22,1.61,.56,2.31,1.05,2.18,2.92,3.07,5.28,3.07,15.94,0,31.88,0,47.82,0h.66v-10.8H3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M9.04,29.47v-3.51H49.54v3.51H9.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M10.8,38.55c1.34-.01,2.42,1.05,2.43,2.38,0,1.32-1.09,2.42-2.41,2.42-1.29,0-2.38-1.07-2.4-2.37-.02-1.33,1.04-2.42,2.38-2.43Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrasadamScanner);
export default __webpack_public_path__ + "static/media/Prasadam Scanner.24c117ffa7fafb9da09114474603cd65.svg";
export { ForwardRef as ReactComponent };